import React, { useContext, useEffect, useState } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { useTranslate } from '../../helpers/useTranslate'
import ProductList from '../ProductList'
import TextLine from '../TextLine'
import Section, { SectionControl } from '../Section/Section'
import ReactGA from 'react-ga'
import styled from 'styled-components'
import AppContext from '../../helpers/AppContext'

export interface Props extends RouteComponentProps {
    className?: string
}

const seeAll = (props: Props) => {
    ReactGA.event({
        category: 'User',
        action: `Clicked 'see all saved'`
    })

    props.history.push('/saved')
}

const SavedProductsPreview: React.FC<Props> = (props) => {
    const { className } = props
    const ctx = useContext(AppContext)
    const { currentUser, storage } = ctx

    if (!currentUser) {
        return null
    }

    const [products, setProducts] = useState<Product[]>([])
    const { translate } = useTranslate()

    useEffect(() => {
        storage
            .getLikedProducts(ctx)
            .then((prods) => {
                const displayedProds = prods
                    .slice()
                    .reverse()
                    .slice(0, 4)
                setProducts(displayedProds)
            })
            .catch((e) => {
                console.log(e)
            })
    }, [setProducts, storage])

    if (!products.length) {
        return null
    }

    const savedProductPreviewClick = () => {
        ReactGA.event({
            category: 'User',
            action: 'Clicked saved product preview'
        })
    }

    const productList = (
        <ProductList
            products={products}
            maxLength={8}
            onProductClick={savedProductPreviewClick}
        />
    )
    const sectionControls: SectionControl[] = []

    const control = {
        content: (
            <TextLine
                className="subtitle"
                text={translate('SEE_ALL')}
                type="small"
                underline={true}
                inline={true}
            />
        ),
        onClick: () => {
            seeAll(props)
        }
    }

    if (ctx.isDesktop) {
        sectionControls.push(control)
    }

    const section = products.length ? (
        <Section
            title={translate('SAVED_PRODUCTS_PREVIEW')}
            body={productList}
            controls={sectionControls}
            bottomCTA={ctx.isDesktop ? undefined : control}
        />
    ) : null
    return <div className={className}>{section}</div>
}

const StyledSavedProductsPreview = styled(SavedProductsPreview)((props) => {
    return {
        minHeight: '350px'
    }
})

export default withRouter(StyledSavedProductsPreview)
